"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.CONTENT = exports.DEFAULT_CONTENT = void 0;
var COMMON = {
    FEE_DISCLAIMER: '*Includes a {{processingFeePercentage}}% bill payment fee',
    FEE_DISCLAIMER_CREDIT: '*Includes a {{processingFeePercentage}}% fee for bill payment and card processing',
    SLC_FEE_DISCLAIMER: '*Includes bill payment fee ({{processingFeePercentage}}% of rent)',
    WAIT_TRY_AGAIN: 'Wait and try again',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    FLEX_ANYWHERE: {
        GET_READY: {
            BEFORE_BP_START: {
                MAIN_TEXT: 'Welcome, {{firstName}}',
                SUBTEXT: 'You’re all set up to pay your rent bill with Flex. You’ll be able to start your rent payment {{bpStartDate}}.',
                CTA: 'Learn more'
            },
            AFTER_BP_START: {
                MAIN_TEXT: 'Ready to pay your rent?',
                CTA: 'Get started'
            }
        },
        RENT_PAYMENT: {
            MAIN_TEXT: 'Make your rent payment',
            CTA: 'Show me how',
            CTA_NEW: 'Learn more'
        },
        FULLY_PAID: {
            MAIN_TEXT: 'You’re all set!',
            SUBTEXT: 'You’ve successfully Flexed your rent this month. You’ll be able to start next month’s rent payment on {{nextBPStartDate}}.',
            CTA: ''
        },
        FAILED_PAYMENT: {
            MAIN_TEXT: 'We failed to process your {{paymentLabel}}',
            SUBTEXT: 'Ensure you have {{failedPaymentAmount}} available when we retry on {{nextAuthAttemptDate}}, or make the payment now.',
            CTA: 'Make payment'
        },
        SCHEDULED_PAYMENT: {
            MAIN_TEXT: 'Your property has been paid!',
            SUBTEXT: 'Your rent has been successfully paid in full. Ensure you have {{upcomingPaymentAmount}} ready for your payment {{date}}.',
            CTA: 'Make payment'
        }
    }
};
/** @deprecated we are moving away from this content providing method - see `packages/screen-content` for v2 implementation */
exports.DEFAULT_CONTENT = {
    SETTINGS_ERRORS: {
        FAILED_TO_LOAD_INFO: 'Couldn’t load settings information'
    },
    GENERIC_ERROR_MODAL: {
        TITLE: COMMON.SOMETHING_WENT_WRONG,
        SUBTITLE: 'We’re having issues processing your request. You can try again in a few moments. If the problem persists, reach out to our support team.'
    },
    TRY_AGAIN: {
        TITLE: COMMON.SOMETHING_WENT_WRONG,
        SUBTITLE: 'We ran into some technical issues.',
        DIRECTIONS: 'Please wait a few minutes and try again. If you continue to hit this error, reach out to our support team.',
        CTA: 'Try again'
    },
    ADDRESS_SELECTION: {
        HEADER: 'Does your property partner with Flex?',
        BODY: 'Search by property name or address. If you don’t see your property here, we’ll do some other checks to see if you can use Flex.',
        SEARCH_INPUT_LABEL: 'Search partner properties',
        DONT_SEE_PROPERTY: 'My property isn’t listed',
        SEARCH_INPUT_PLACEHOLDER: 'E.g.“Shift apartments CA 90201”',
        LOCATION_DATA: 'Improve results with location data'
    },
    PORTAL_ADDRESS_ENTRY: {
        HEADER: 'What’s your address?',
        BODY: 'Your property isn’t in our network yet, but you may still be eligible to use Flex as long as you pay rent online.',
        CTA: 'Continue'
    },
    RENT_AMOUNT: {
        AMOUNT_CHANGES: 'What if the amount changes each month?',
        AMOUNT_CHANGE_MODAL_HEADER: 'What if the amount changes each month?',
        AMOUNT_CHANGE_MODAL_BODY_ONE: 'We understand that sometimes your bill amount might be a little higher or lower. As long as it’s close, don’t worry!',
        AMOUNT_CHANGE_MODAL_BODY_TWO: 'If there is a big difference between your reported rent and the attempted payment, we’ll follow up for more information.',
        AMOUNT_CHANGE_MODAL_CTA: 'Close',
        CONFIRM_HEADER: 'Confirm your rent amount',
        RENT_INPUT_LABEL: 'Monthly rent',
        CTA: 'Continue',
        CLASSIC: {
            HEADER: 'How much is your rent bill?',
            BODY: 'Include any fees that appear on your monthly rent bill, like pet fees or utilities.'
        },
        FLEX_ANYWHERE: {
            HEADER: 'Tell us about your lease',
            BODY: 'We’ll use this info to estimate your payments and verify who is receiving your rent.\n\nMake sure to include any fees that appear on your monthly rent bill, like pet fees or utilities.',
            PROPERTY_NAME_INPUT_LABEL: 'Property name or landlord name',
            PROPERTY_NAME_HELPER_TEXT: 'If you don’t know, provide your management company’s name.'
        }
    },
    LANDING_RENT_AMOUNT: {
        LOGIN_CTA: 'Already have an account? Log in',
        ESTIMATE_DISCLAIMER: 'This is an estimated range. Actual payment amounts and membership are subject to application and credit approval.',
        ESTIMATE_CTA: 'Let’s go'
    },
    SOFT_CREDIT_CHECK: {
        FEDERAL_LAW_DISCLAIMER: 'Federal law requires us to collect this info. ',
        LINK_TEXT: 'Why?',
        INCOME_LABEL: 'Annual income',
        TITLE: 'Connect to your credit profile',
        BULLETS: [
            'This process will not affect your credit score',
            'Your income will not impact your initial credit decision',
        ]
    },
    WHY_WE_COLLECT_PERSONAL_INFO_MODAL: {
        TITLE: 'Why we collect personal information',
        MAIN_TEXT_1: 'Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.',
        MAIN_TEXT_2: 'This information is collected to help the government fight the funding of terrorism and money laundering activities.'
    },
    INFO_COLLECTION_MODAL: {
        TITLE: 'Why does Flex have to collect certain personal info?',
        BODY: 'Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.\n\nThis information is collected to help the government fight the funding of terrorism and money laundering activities.',
        CTA: 'Close'
    },
    ACCEPTANCE_OFFER_DETAILS: {
        HEADER: 'You made it to the last step!',
        BODY: 'Remember, Flex pays your full rent directly to your property manager. Review your payment schedule, which reflects your Flex credit line and any applicable fees.',
        INITIAL_PAYMENT_LABEL: '1st payment',
        AUTHORIZATION: 'I authorize Flex to charge my card according to this payment schedule. I acknowledge that payment amounts are estimates and may vary.',
        AGREE: "By clicking 'Accept' I agree to:",
        FEE_DISCLAIMER: COMMON.FEE_DISCLAIMER,
        FEE_DISCLAIMER_CREDIT: COMMON.FEE_DISCLAIMER_CREDIT
    },
    ACCEPTANCE_OFFER_DETAILS_OVERWRITE: {
        FEE_DISCLAIMER: COMMON.FEE_DISCLAIMER,
        FEE_DISCLAIMER_CREDIT: COMMON.FEE_DISCLAIMER_CREDIT
    },
    OON_HOW_FLEX_WORKS: {
        BULLETS: [
            {
                HEADER: 'Get ready',
                BODY: 'When you’re ready to pay your rent, confirm the amount of your rent bill in the Flex app.'
            },
            {
                HEADER: '1st payment',
                BODY: 'Make your 1st payment to activate your Flex {{paymentMethod}}.'
            },
            {
                HEADER: 'Rent payment',
                BODY: 'Use your Flex {{paymentMethod}} to pay rent in your rent portal.'
            },
            {
                HEADER: '2nd payment',
                BODY: 'We’ll automatically process your 2nd payment on the date you selected.'
            },
        ]
    },
    DASHBOARD_OON_RENT_AMOUNT: {
        HEADER: 'How much is your rent bill?',
        BODY: 'Log into your rent portal and enter the total amount due on this month’s rent bill.',
        RENT_INPUT_LABEL: 'Bill Amount',
        AMOUNT_CHANGES: 'What if there are extra fees?',
        AMOUNT_CHANGE_MODAL_HEADER: 'What if there are extra fees?',
        AMOUNT_CHANGE_MODAL_BODY_ONE: 'We understand that sometimes properties charge additional fees that don’t appear on your bill. Don’t worry! Your rent payment will still be approved if it’s a little higher than the bill amount.',
        AMOUNT_CHANGE_MODAL_BODY_TWO: 'Note that if there is a big difference between your reported rent and the attempted payment, we’ll follow up for more information.',
        AMOUNT_CHANGE_MODAL_CTA: 'Done',
        CTA: 'Continue'
    },
    CUSTOMIZE_YOUR_SCHEDULE: {
        HEADER: 'Customize your schedule',
        BODY: 'Set up your payment schedule by selecting a date for your 2nd payment to Flex.',
        FIRST_PAYMENT: '1st payment',
        FIRST_PAYMENT_INFO: 'When rent is due',
        SECOND_PAYMENT: '2nd payment',
        SECOND_PAYMENT_INFO: 'Choose date',
        SECOND_PAYMENT_SELECTED_INFO: 'of the month',
        POSITIVE_FEEDBACK_HEADER: 'Smart thinking!',
        POSITIVE_FEEDBACK_BODY: 'Scheduling earlier gives you better control over your cash flow.',
        NEGATIVE_FEEDBACK_HEADER: 'Are you sure?',
        NEGATIVE_FEEDBACK_BODY: 'Scheduling late in the month can make it difficult to get prepared for the following month’s rent.',
        BILL_PAYMENT_FEE: '(includes {{fee}}% bill payment fee)',
        INTEREST_FEE: '(includes {{fee}}% interest)',
        CTA: 'Continue'
    },
    RESUME_ONBOARDING: {
        HEADER: 'Welcome back, {{name}}!',
        BODY: 'Just a few more steps until you can Flex your rent next month.',
        BODY_ITS_BEEN_A_WHILE: 'It’s been a while. Let’s review your information to make sure it’s up to date.',
        CTA: 'Let’s go'
    },
    CONNECT_CARD: {
        HEADER: 'Let’s add your card',
        BODY_LINE_1: 'Link the card you’d like Flex to use for your rent payments and membership fee. Don’t worry, we won’t charge your card now.',
        BODY_LINE_2: 'When using a debit card, a {{debitProcessingFee}}% fee will be applied for bill payment each month you use Flex, with no additional fee for card processing.',
        BODY_LINE_3: 'When using a credit card, a {{creditProcessingFee}}% fee will be applied for bill payment and card processing each month you use Flex.',
        CTA: 'Add card details'
    },
    PAYMENT_DETAILS: {
        SECTION_TITLE: 'Payment details',
        PAYMENT_DATE_SECTION_TITLE: 'Payment date',
        FEE_DETAIL: 'Bill payment fee ({{processingFee}}% of rent)',
        FEE_DETAIL_CREDIT: 'Bill payment + card processing fee ({{processingFee}}% of rent)',
        FEE_DETAIL_MONTHLY_RATE: '{{processingFee}}% monthly rate',
        FEE_DETAIL_INTEREST: 'Interest ({{processingFee}}%)',
        ESTIMATED: '*Estimated',
        MAKE_PAYMENT: 'Make payment',
        TOTAL_LABEL: 'Total',
        REMAINING_BALANCE_LABEL: 'Remaining balance',
        FUND_EARLY_CTA: 'Fund early',
        RESCHEDULE_CTA: 'Reschedule',
        BILL_PAYMENT_TOTAL: 'Total paid',
        ADDITIONAL_DEPOSIT: 'The rent payment you made was higher than expected. Please make your additional payment by 5pm ET on {{date}} so we can process your rent.'
    },
    BILL_PAYMENT_FEE_LEARN_MORE_MODAL: {
        HEADER: 'Bill payment and card processing fees',
        BODY_LINE_1: 'Flex charges a {{bpFee}}% bill payment fee on all transactions, which enables us to continually improve our product experience.',
        BODY_LINE_2: 'When using a debit card, no other fees will be applied.',
        BODY_LINE_3: 'When using a credit card, a {{creditProcessingFee}}% processing fee will be applied.',
        CTA: 'Close'
    },
    PAY_NOW: {
        PAYMENT_AMOUNT_SECTION_TITLE: 'Payment amount',
        FEE_DETAIL: ' (includes fees)',
        STORED_FUNDS_LABEL: 'Flex Funds',
        BILL_PAY_FEE: 'Bill payment fee',
        ADDITIONAL_DEPOSIT: {
            TITLE: 'Make your additional payment',
            PARAGRAPH: 'It looks like your rent was more than we expected. In order to complete your rent payment, please make this additional payment.',
            OPT_OUT: {
                TEXT: 'Can’t make this payment?',
                CTA: 'Don’t use Flex this month'
            }
        },
        PARTIAL_PAYMENT: {
            TITLE: {
                REPAYMENT: 'Make a payment',
                OUTSTANDING_BALANCE: 'Pay your outstanding balance'
            },
            PARAGRAPH: {
                ACTIVE: 'Pay off your balance to remain in good standing with Flex.',
                REPAYMENT_PAUSE_OR_CANCEL: 'Pay off your balance to avoid negative consequences after you pause or cancel your membership.',
                PAUSED_DQ: 'Pay off your balance to remain in good standing with Flex and be eligible to resume service.',
                CANCELED_DQ: 'Pay off your outstanding balance to avoid collections and keep access to Flex services.',
                SUSPENDED_DQ: 'Your account has been paused because you have an outstanding balance with Flex. Pay off your outstanding balance to avoid collections.'
            },
            AMOUNT: {
                OUTSTANDING_BALANCE: 'Outstanding balance'
            },
            TAB: {
                TOTAL: 'Total balance',
                CUSTOM: 'Custom amount'
            },
            BREAKDOWN: {
                CUSTOM: 'Custom amount',
                AMOUNT_PLACEHOLDER: '0.00',
                CARD: 'Charged to card'
            },
            VALILDATION: {
                EXCEEDED_MAX_AMOUNT: 'Must be less than {{amount}}',
                BELOW_MIN_AMOUNT: 'Must be more than {{amount}}'
            },
            CTA: 'Make payment',
            MODAL: {
                SUCCESS: {
                    TITLE: 'Thanks for your payment!',
                    PARAGRAPH: 'We’ve processed your payment of {{amount}}.',
                    CTA: 'Done'
                },
                ERROR: {
                    GENERIC: {
                        TITLE: 'Couldn’t complete payment',
                        PARAGRAPH_ONE: 'We couldn’t complete your payment of {{amount}}.',
                        PARAGRAPH_TWO_REPAYMENT: 'Before attempting this payment again, make sure you have enough funds available in your account and that your card information is correct. We’ll still automatically attempt to collect the total balance on {{date}}.',
                        PARAGRAPH_TWO_OUTSTANDING_BALANCE: 'Before attempting this payment again, make sure you have enough funds available in your account and that your card information is correct.',
                        CTA: 'Done'
                    },
                    FUNDS_SUCCESS_CARD_FAILURE: {
                        TITLE: 'Partially completed payment',
                        PARAGRAPH_ONE: 'We successfully collected your Flex Funds, but couldn’t charge your card for the remaining {{amount}}.',
                        PARAGRAPH_TWO_REPAYMENT: 'Before attempting this payment again, make sure you have enough funds available in your account and that your card information is correct. We’ll still automatically attempt to collect the remaining balance on {{date}}.',
                        PARAGRAPH_TWO_OUTSTANDING_BALANCE: 'Before attempting this payment again, make sure you have enough funds available in your account and that your card information is correct.',
                        CTA: 'Done'
                    }
                }
            }
        },
        BREAKDOWN: {
            EXPECTED: 'Expected',
            ACTUAL: 'Actual',
            DIFFERENCE: 'Difference'
        }
    },
    REGISTER_CARD: {
        PROCESSING_FEE_DISCLAIMER: 'Credit cards subject to a processing fee',
        BODY_IN_APP: 'To access your line of credit, link the card you’d like to use for your payments to Flex (including the monthly membership fee.)'
    },
    WALLET: {
        WITHDRAW_FUNDS: {
            WITHDRAW_FUNDS_OVER_BALANCE: 'Can’t exceed your current balance of ${{maxWithdrawalAmount}}',
            WITHDRAW_FUNDS_RETURN_FUNDS: 'Withdraw funds to',
            WITHDRAW_FUNDS_DEBIT_CARD: '{{cardType}} card x{{lastFourDigitsOfCard}}',
            WITHDRAW_FUNDS_NO_CREDIT_CARDS: 'Only debit cards can be used to withdraw funds',
            WITHDRAWABLE_BALANCE: '${{withdrawableBalance}} is available to withdraw'
        },
        WITHDRAW_FUNDS_RENT_PAYMENT_PROCESSING_MODAL: {
            HEADER: 'Couldn’t complete withdrawal—rent payment in progress',
            BODY: 'We were unable to withdraw your funds because we’re in the process of paying your rent. Please wait until your rent payment has been paid or stopped before trying again.'
        },
        WITHDRAW_FUNDS_MODAL: {
            HEADER: '${{withdrawalAmount}} has been withdrawn',
            WITHDRAW_FUNDS_SUCCESS: 'The funds have been returned to your debit card ending in {{last4OfCard}}. It can take 3-5 business days for this to be reflected in your account.'
        },
        WITHDRAW_FUNDS_LEARN_MORE_MODAL: {
            HEADER: 'Why can’t I withdraw all of my funds?',
            BODY: 'Since you have an outstanding balance with Flex, we need to keep your minimum deposit of ${{minimumDeposit}} in your deposit funds.',
            CTA: 'Close'
        },
        WITHDRAW_FUNDS_FAILURE_MODAL: {
            HEADER: 'Couldn’t complete withdrawal',
            WITHDRAW_FUNDS_FAILURE_LINE_1: 'We were unable to transfer ${{withdrawalAmount}} to your debit card.',
            WITHDRAW_FUNDS_FAILURE_LINE_2: 'Before attempting this transaction again, make sure your debit card information is correct.'
        },
        WITHDRAW_FUNDS_FAILURE_CHANGED_CARD_24HOURS_MODAL: {
            HEADER: 'You’ve changed your card recently',
            WITHDRAW_FUNDS_CHANGED_CARD_TEXT: 'You have to wait 24 hours after your changing your payment method to make a withdrawal.'
        },
        ADD_FUNDS: {
            MAX_DEPOSITS_BANNER_TEXT: '{{depositsRemaining}} deposits remaining this month',
            MAX_DEPOSITS_BANNER_TEXT_ONE_LEFT: '1 deposit remaining this month',
            MAX_DEPOSITS_ZERO_LEFT_BANNER_TEXT: 'No more deposits this month',
            ADD_FUNDS_NO_CREDIT_CARDS: 'Only debit cards can be used to add funds',
            ADD_FUNDS_DEBIT_CARD: '{{cardType}} card x{{lastFourDigitsOfCard}}',
            RETURN_FUNDS_STRING: 'Add funds from',
            NEW_BALANCE: 'New balance will be ${{updatedBalance}}',
            MAX_TO_BE_ADDED: '${{maxAddFundsAmount}} is the maximum you can add',
            MAX_BALANCE: 'You reached your maximum balance',
            CURRENT_BALANCE: 'Current balance is ${{currentBalance}}'
        },
        ADD_FUNDS_DEPOSIT_LIMIT_MODAL: {
            TITLE: 'Deposit limit',
            TEXT: 'You’re only able to add funds 10 times each month. This limit resets on the 1st of every month.'
        },
        ADD_FUNDS_MODAL: {
            ADD_FUNDS_SUCCESS: ' has been added to your funds!'
        },
        ADD_FUNDS_FAILURE_MODAL: {
            HEADER: 'Couldn’t complete transaction',
            ADD_FUNDS_FAILURE_LINE_1: 'We were unable to add ${{addFundsAmount}} to your funds.',
            ADD_FUNDS_FAILURE_LINE_2: 'Before attempting this transaction again, make sure your debit card has enough funds available and that your card information is correct.'
        },
        ADD_FUNDS_MAX_DEPOSIT_REACHED_MODAL: {
            HEADER: 'Deposit limit reached',
            ADD_FUNDS_MAX_DEPOSITS_TEXT: 'You’ve reached your maximum number of deposits allowed in a 30-day period. As a reminder, you can only deposit funds up to 5 times every 30 days.'
        },
        ADD_FUNDS_NOT_AVAILABLE_MODAL: {
            HEADER: 'Adding funds is unavailable',
            ADD_FUNDS_NOT_AVAILABLE_TEXT: 'You can’t add to your Flex Funds when your membership is canceled or suspended.'
        },
        ADD_FUNDS_OUTSTANDING_BALANCE_MODAL: {
            HEADER: 'You have an outstanding balance',
            ADD_FUNDS_OUTSTANDING_BALANCE_TEXT: 'You currently have an outstanding balance of ${{outstandingBalance}}. Any funds added will be immediately applied to your outstanding balance and will not be available for withdrawal.',
            CTA: 'Continue'
        },
        WITHDRAW_FUNDS_24_HOUR_WAIT_MODAL: {
            HEADER: 'You must wait 24 hours to withdraw to a new card',
            MAIN_TEXT: 'This is a new payment method. For security reasons, we require a 24 hour waiting period before you can withdraw to a new card.',
            CTA_TEXT: 'Update card anyway'
        },
        WITHDRAW_FUNDS_MAX_WITHDRAWALS_MODAL: {
            HEADER: 'Withdraw limit reached',
            MAIN_TEXT: 'You’ve reached your maximum number of withdrawals allowed in a 30-day period. As a reminder, you can only withdraw funds up to 3 times every 30 days.',
            CTA_TEXT: 'Done'
        },
        WITHDRAW_FUNDS_CARD_UPDATED_MODAL: {
            HEADER: 'Your card has been updated',
            CARD_UPDATED_LINE_2: 'Your payments have been updated to reflect your new payment method.'
        }
    },
    CARD_PAYMENT_METHOD: {
        SECTION_TITLE: 'Payment method',
        CARD_DETAILS: '{{cardType}} card x{{lastFourDigits}}'
    },
    TERMS_ACCEPT_LINK: {
        TITLE: 'You’re good to go!',
        SUBTITLE: "Thanks for accepting the agreements. Head to Settings in the Flex app to view them at any time.",
        DOWNLOAD_TITLE: 'Don’t have the Flex app? Download it to keep up with your Flex account.',
        EXPIRED_SUBTITLE: 'Your link has expired. We’ll send a new link in just a few moments. Please check your email and try again.',
        ERROR_TITLE: 'Something went wrong',
        ERROR_SUBTITLE: 'We’re having issues processing your request. You can try again in a few moments. If the problem persists, reach out to our support team.'
    },
    VERIFY_EMAIL_LINK: {
        TITLE: 'Email verified!',
        SUBTITLE: 'You’ve successfully secured your Flex account.',
        DOWNLOAD_TITLE: 'Stay in the loop! Download the Flex app for real-time updates on your account status.',
        ERROR_TITLE: 'Something went wrong',
        ERROR_SUBTITLE: 'This verification link has expired. Please login to your Flex account to resend the email verification link.'
    },
    ADDITIONAL_ACTION_REQUIRED: {
        DELETE: {
            TITLE: 'Additional action required to delete data',
            PARAGRAPH_ONE: 'We’re sorry to see you go! In order to proceed, you’ll first need to do the following:',
            PARAGRAPH_TWO: 'Then, come back to the Privacy page to delete your account and data.',
            PARAGRAPH_THREE: 'Please note that deleting your data will close your Flex account and you will lose access to the app. If you might want to use Flex in the future, consider keeping your membership canceled.',
            CTA: 'Manage membership'
        },
        CANCEL: {
            TITLE: 'Withdraw your ${{storedFunds}} before you cancel',
            PARAGRAPH_ONE: 'You must withdraw your Flex Funds in Settings > Payment methods before canceling your Flex membership.',
            CTA: 'Go to Flex Funds'
        }
    },
    AGREEMENTS_UPDATE: {
        TITLE: 'Updates to Flex agreements',
        BODY_LINE1: 'To access this feature, you’ll need to accept new agreements that enable you to store funds directly with Flex.',
        BODY_LINE2: 'Please review and agree to these documents.',
        LINK_BUTTON: 'Not now',
        CTA: 'Continue',
        AGREED: 'I have reviewed and agree to the documents above'
    },
    EMAIL_VERIFICATION_STATUS: {
        EMAIL_VERIFIED_TEXT: 'Verified',
        VERIFY_EMAIL_BUTTON_TEXT: 'Verify your email',
        EMAIL_SENT_BOLD: 'Email sent.',
        EMAIL_SENT_TEXT: 'Check your inbox to verify.',
        RESEND_TEXT: 'Resend'
    },
    EMAIL_SENT_DISPLAY_MODAL: {
        TITLE: 'Check your inbox',
        EMAIL_SENT_TEXT: 'We’ve sent an email to ',
        BODY: 'Open the email and tap the ’Verify’ button. If you don’t see the email, make sure to check your spam folder.',
        CTA: 'Done'
    },
    EMAIL_SEND_FAILED_DISPLAY_MODAL: {
        TITLE: 'Whoops!',
        BODY: 'We ran into a technical problem. Try again in a few moments.',
        CTA: 'Close'
    },
    EMAIL_ALREADY_VERIFIED_MODAL: {
        TITLE: 'Your email is already verified!',
        BODY: 'Thanks for double checking and keeping your account secure.',
        CTA: 'Close'
    },
    VERIFIED_PHONE_CHANGE_MODAL: {
        TITLE: 'Check your inbox',
        EMAIL_SENT_TEXT: 'We’ve sent an email to ',
        BODY: 'Open the email and tap the ‘Change phone number’ button. If you don’t see the email, make sure to check your spam folder.\n\nThe link will be active for 10 minutes.',
        CTA: 'Done'
    },
    APP_REDIRECT: {
        TITLE: 'Open this link on a mobile device',
        BODY: 'You’ll need the Flex app to access this link, if you don’t have the Flex app installed, please download it and try again'
    },
    MARKDOWN: {
        SUCCESS_MODAL: {
            TITLE: 'Email sent!',
            BODY: 'We’ve sent you an email with your document so that you can access it on another device.',
            CTA: 'Done'
        },
        ERROR_MODAL: {
            TITLE: 'Something went wrong',
            BODY: 'We couldn’t complete your request. Please try again in a few moments.',
            CTA: 'Done'
        }
    },
    SERVICE_ISSUES: {
        SELF_PAY: {
            SELF_PAY_OFFERED: {
                RENT_TRACKER_MAIN_TEXT: 'Help us complete your rent payment.',
                RENT_TRACKER_SUBTEXT: 'Unfortunately, we couldn’t complete your rent payment. Use the provided {{selfPayPaymentMethod}} to pay rent directly to your property.',
                SELF_PAY_OFFERED_SCREEN: {
                    TITLE: 'Help us complete your rent payment',
                    DDA_MAIN_TEXT: 'We’re unable to pay your rent automatically this month. But don’t worry! You can still use Flex by self-submitting your rent payment.',
                    VC_MAIN_TEXT: 'We’re unable to pay your rent automatically this month. But don’t worry! You can still use Flex by self-submitting your rent payment. Debit card fees may occur. ',
                    LOADED_PAYMENT_METHOD: "We\u2019ll provide you with a {{paymentMethod}} loaded with ${{rentAmount}} to manually pay your rent",
                    SELF_PAY_AGREEMENTS_TEXT: 'By self-submitting you agree to ',
                    FEES_DISCLAIMER: 'Your property may charge additional fees to use a debit card. We will update your 2nd payment to include any third-party fees.',
                    CARDHOLDER_AGREEMENT: 'Flex’s Card Holder Agreement ',
                    SHORT_LONG_FORM_AGREEMENT: 'Short and Long Form Fee Schedules ',
                    ACKNOWLEDGE_AGREEMENT: 'and acknowledge ',
                    PRIVACY_NOTICE: 'Patriot Bank’s Privacy Notice',
                    LEARN_MORE: 'Learn more',
                    DEBIT_FEES_MODAL_TITLE: 'Debit card fees',
                    DEBIT_FEES_MODAL_TEXT: 'Your property may charge additional fees to use a debit card. We will update your 2nd payment to include any third-party fees.'
                }
            },
            SELF_PAY_DETAILS: {
                BANNER: {
                    MESSAGE: 'Make payment by 8pm ET on {{ bpMonth }} {{ordinalBpEndDay}}'
                },
                DDA: {
                    HEADER: 'Flex bank account details',
                    MAIN_TEXT: 'Use this bank account to pay your rent. Up to {{rentAmount}} is available for your rent payment.',
                    HAVING_ISSUES: 'Having issues? ',
                    MORE_ACCOUNT_INFO: 'Need more account info?'
                },
                HAVING_ISSUES_MODAL: {
                    HEADER: 'Having trouble?',
                    MAIN_TEXT: 'If you’re having issues with the provided payment method, here are some other options',
                    DONT_USE_FLEX_MAIN_TEXT: 'Don’t use Flex this month',
                    DONT_USE_FLEX_SUB_TEXT: 'Get a refund for your 1st payment',
                    SWITCH_TO_DEBIT_CARD_MAIN_TEXT: 'Switch to debit card',
                    SWITCH_TO_DEBIT_CARD_SUB_TEXT: 'If your portal isn’t accepting ACH/bank transfers',
                    HELP_MAIN_TEXT: 'Help',
                    HELP_SUB_TEXT: 'Learn more about using self-submit'
                },
                DONE_MODAL: {
                    TITLE: 'Have you paid your rent?',
                    MAIN_TEXT: 'Please confirm that you have self-submitted your rent payment with the provided {{selfPayPaymentMethod}}',
                    CONFIRM_CTA: 'Yes, I paid',
                    NOT_YET: 'Not yet'
                }
            },
            SELF_PAY_PENDING: {
                BEFORE_BP_CLOSE: {
                    RENT_TRACKER_MAIN_TEXT: 'We’re working to confirm your payment',
                    RENT_TRACKER_SUBTEXT: 'If you’ve self-submitted your rent payment, we’ll notify you when the payment has been processed. This may take up to 4 days.'
                },
                AFTER_BP_CLOSE: {
                    RENT_TRACKER_MAIN_TEXT: 'Self-submitted payments are processing',
                    RENT_TRACKER_SUBTEXT: 'Your action was needed to complete rent payment this month. If you used the provided payment method to self-submit, we’ll notify you when the payment has been processed. This may take up to 4 days.'
                },
                PENDING_SCREEN: {
                    TITLE: 'Self-submitted payments are processing',
                    PARAGRAPH_1: 'Your action was needed to complete rent payment this month. If you used the provided payment method to self-submit, we’ll notify you when the payment has been processed. This may take up to 4 days.',
                    CTA: 'Done',
                    OPT_OUT_TEXT: 'Didn’t self-submit your rent?',
                    OPT_OUT_LINK_TEXT: 'Don’t use Flex this month'
                }
            },
            SELF_PAY_OPTED_OUT: {
                MAIN_TEXT: 'You are not using Flex this month',
                SUB_TEXT: 'We have refunded your 1st payment to Flex and you will need to pay your rent yourself this month.'
            }
        },
        INSUFFICIENT_FUNDS: {
            SLC_MAIN_TEXT: 'Deposit not collected',
            MAIN_TEXT: 'Your 1st payment failed',
            SUB_TEXT: 'We couldn’t complete your payment due to insufficient funds, but we’ll keep trying to process the payment.',
            SLC_SUB_TEXT: 'We couldn’t collect your deposit due to insufficient funds, but we’ll keep trying to process the payment.',
            CTA_TEXT: 'View details',
            SLC_SERVICE_ISSUE_SCREEN_HEADER: 'Deposit not collected',
            SERVICE_ISSUE_SCREEN_HEADER: 'Your 1st payment failed',
            SERVICE_ISSUE_SCREEN_BOLD_MAIN_TEXT: 'We couldn’t complete your payment of {{paymentAmount}} due to insufficient funds available. ',
            SLC_SERVICE_ISSUE_SCREEN_BOLD_MAIN_TEXT: 'We couldn’t collect your deposit of {{paymentAmount}} due to insufficient funds available. ',
            SERVICE_ISSUE_SCREEN_MAIN_TEXT: 'We’ll try again every {{retryHours}} until {{retryTime}} ET on {{retryDay}}.',
            SERVICE_ISSUE_SCREEN_SUB_TEXT: 'You can also manually retry now or update your card details.',
            SERVICE_ISSUE_SCREEN_PRIMARY_CTA_TEXT: 'Pay now',
            SLC_SERVICE_ISSUE_SCREEN_PRIMARY_CTA_TEXT: 'Make deposit',
            SERVICE_ISSUE_SCREEN_SECONDARY_CTA_TEXT: 'Update card'
        },
        GENERIC_FAILURE: {
            SLC_MAIN_TEXT: 'Deposit not collected',
            MAIN_TEXT: 'Your 1st payment failed',
            SUB_TEXT: 'There was a temporary issue with your card or bank, but we’ll keep trying to process the payment.',
            CTA_TEXT: 'View details',
            SLC_SERVICE_ISSUE_SCREEN_HEADER: 'Deposit not collected',
            SERVICE_ISSUE_SCREEN_HEADER: 'Your 1st payment failed',
            SERVICE_ISSUE_SCREEN_BOLD_MAIN_TEXT: 'We couldn’t complete your payment of {{paymentAmount}} due to a temporary issue with your card or bank. ',
            SLC_SERVICE_ISSUE_SCREEN_BOLD_MAIN_TEXT: 'We couldn’t collect your deposit of {{paymentAmount}} due to a temporary issue with your card or bank. ',
            SERVICE_ISSUE_SCREEN_MAIN_TEXT: 'We’ll try again every {{retryHours}} hours until {{retryTime}} ET on {{retryDay}}.',
            SERVICE_ISSUE_SCREEN_SUB_TEXT: 'You can also manually retry now or update your card details.',
            SERVICE_ISSUE_SCREEN_PRIMARY_CTA_TEXT: 'Pay now',
            SLC_SERVICE_ISSUE_SCREEN_PRIMARY_CTA_TEXT: 'Make deposit',
            SERVICE_ISSUE_SCREEN_SECONDARY_CTA_TEXT: 'Update card'
        },
        UPDATE_CARD: {
            SLC_MAIN_TEXT: 'Deposit not collected',
            MAIN_TEXT: 'Your 1st payment failed [Action required]',
            SUB_TEXT: 'We couldn’t complete your payment due to an issue with your card.',
            SLC_SUB_TEXT: 'We couldn’t collect your deposit due to an issue with your card.',
            CTA_TEXT: 'View details',
            SLC_SERVICE_ISSUE_SCREEN_HEADER: 'Deposit not collected',
            SERVICE_ISSUE_SCREEN_HEADER: 'Your 1st payment failed [Action required]',
            SERVICE_ISSUE_SCREEN_BOLD_TEXT: 'To continue with Flex, update your card by {{retryTime}} ET on {{retryDateString}}, so we can try to process the payment again.',
            SERVICE_ISSUE_SCREEN_MAIN_TEXT: 'We couldn’t complete your payment of {{paymentAmount}} due to an issue with your card.',
            SLC_SERVICE_ISSUE_SCREEN_MAIN_TEXT: 'We couldn’t collect your deposit of {{paymentAmount}} due to an issue with your card.',
            SERVICE_ISSUE_SCREEN_PRIMARY_CTA_TEXT: 'Update card'
        },
        DEFAULT_FAILURE: {
            SLC_MAIN_TEXT: 'Deposit not collected [Action required]',
            MAIN_TEXT: 'Your 1st payment failed [Action required]',
            SUB_TEXT: 'We couldn’t complete your payment due to an issue with your card or bank.',
            CTA_TEXT: 'View details',
            SLC_SERVICE_ISSUE_SCREEN_HEADER: 'Deposit not collected [Action required]',
            SERVICE_ISSUE_SCREEN_HEADER: 'Your 1st payment failed [Action required]',
            SERVICE_ISSUE_SCREEN_BOLD_TEXT: 'To continue with Flex, update your card by {{retryTime}} ET on {{retryDateString}}, so we can try to process the payment again.',
            SERVICE_ISSUE_SCREEN_MAIN_TEXT: 'We couldn’t complete your payment of {{paymentAmount}} due to an issue with your card.',
            SLC_SERVICE_ISSUE_SCREEN_MAIN_TEXT: 'We couldn’t collect your deposit of {{paymentAmount}} due to an issue with your card.',
            SERVICE_ISSUE_SCREEN_SECOND_TEXT: 'If you think the transaction should have completed, you can try contacting your card issuer to see if they can resolve the issue.',
            SERVICE_ISSUE_SCREEN_PRIMARY_CTA_TEXT: 'Update card',
            SERVICE_ISSUE_SCREEN_SECONDARY_CTA_TEXT: 'Pay now'
        },
        PAST_DOWNPAYMENT_DEADLINE: {
            MAIN_TEXT: 'Payment processing',
            SUB_TEXT: 'The rent payment window has closed, it may take up to 2 hours for Flex to process payments.'
        },
        ADDITIONAL_DEPOSIT_NEEDED: {
            MAIN_TEXT: 'Additional {{paymentAmount}} needed to process your rent payment',
            SUB_TEXT: 'Your rent was higher than expected. Please make an additional payment by {{date}} so we can process your rent.',
            CTA_TEXT: 'Make payment',
            PROCESSING: {
                MAIN_TEXT: 'Processing your rent payment',
                SUB_TEXT: 'We are reviewing the rent payment you made to your property, which can take up to two business days.'
            },
            COMPLETE: {
                MAIN_TEXT: 'Your property has been paid!',
                SUB_TEXT: 'Your rent has been successfully paid in full. Ensure you have ${{paymentAmount}} ready for your payment in 12 days.'
            }
        },
        PORTAL_CREDENTIALS_RELINK: {
            MAIN_TEXT: 'We couldn’t access your rent portal',
            SUB_TEXT: 'Update your rent portal connection to continue Flex service.',
            CTA_TEXT: 'Update connection'
        }
    },
    UPDATE_RENT_AMOUNT: {
        TITLE: 'How much is your rent bill?',
        SUBTITLE: 'Include any fees that appear on your monthly rent bill, like pet fees or utilities.',
        HELP_CTA: 'What if the amount changes each month?',
        FIELD_LABEL: 'Monthly rent',
        HELP_TEXT: 'You can make changes for the current month up until Flex confirms your rent bill amount. Updating your monthly rent will not result in any changes to your credit line.',
        SUBMIT_CTA: 'Review schedule',
        HELP_MODAL_TITLE: 'What if the amount changes each month?',
        HELP_MODAL_BODY: "We understand that sometimes your bill amount might be a little higher or lower. As long as it\u2019s close, don\u2019t worry!\n\nIf there is a big difference between the amount you enter and your actual rent bill, we\u2019ll follow up for more information.",
        HELP_MODAL_CLOSE_CTA: 'Close'
    },
    CONFIRM_UPDATE_RENT_AMOUNT: {
        TITLE: 'Payment schedule',
        SUBTITLE: "Based on your rent bill of ${{dollars}}, here's how you\u2019ll pay Flex.",
        TABLE_TITLE: 'Each month',
        FEE_DISCLAIMER_LABEL: COMMON.FEE_DISCLAIMER,
        FEE_DISCLAIMER_LABEL_CREDIT: COMMON.FEE_DISCLAIMER_CREDIT,
        FIRST_PAYMENT_DESCRIPTION: 'When rent is due',
        SUBMIT_CTA: 'Confirm'
    },
    UPDATE_RENT_AMOUNT_SUCCESS_MODAL: {
        TITLE: 'Monthly rent updated',
        BODY: "Your monthly rent amount has been updated to ${{dollars}}. \n\nYour schedule has been updated to reflect your new rent amount.",
        CLOSE_CTA: 'Close'
    },
    UPDATE_RENT_AMOUNT_ERROR_MODAL: {
        TITLE: 'Rent update failed',
        BODY: 'Sorry, we couldn’t complete your request due to a technical issue. Try again or ',
        BODY_PART_TWO: ' if the problem persists.',
        CLOSE_CTA: 'Close',
        RATE_LIMIT_ERROR_TITLE: COMMON.WAIT_TRY_AGAIN,
        RATE_LIMIT_ERROR_BODY: 'We noticed you tried changing your monthly rent very quickly after your last attempt. Please wait a few moments before trying again.'
    },
    SETTINGS_PROPERTY: {
        PROPERTY_LABEL: 'Property',
        PROPERTY_CTA: 'Relink',
        PROPERTY_OON_CTA: 'Update',
        UPDATE_RENT_LABEL: 'Monthly rent estimate',
        UPDATE_RENT_CTA: 'Update',
        UNAVAILABLE_MODAL_TITLE: "Can\u2019t make changes to monthly rent",
        UNAVAILABLE_MODAL_BODY: 'Your account needs to be active in order for you to update your rent amount',
        UNAVAILABLE_MODAL_CTA: 'Done',
        PORTAL_LOGIN_LABEL: 'Portal connection',
        PORTAL_LOGIN_CTA: 'Update',
        PORTAL_LOGIN_INVALID_CREDS: 'Please update your portal connection'
    },
    RENT_REPORTING: {
        TOAST: {
            TITLE: 'Introducing rent reporting',
            MESSAGE: 'Included in your membership, you’re opted into rent reporting. Build credit history when you pay rent on time.',
            CTA: 'Go to Settings'
        },
        SCREEN: {
            MESSAGE_SINGULAR: 'When you pay rent with Flex, we’ll report your on-time payments to the following credit bureau:',
            MESSAGE_PLURAL: 'When you pay rent with Flex, we’ll report your on-time payments to the following credit bureaus:',
            INFO_BULLET: [
                'Included with your Flex membership',
                'Establish on-time payment history',
                'Build your credit profile',
            ],
            SWITCH_TITLE: 'Rent reporting',
            SWITCH_LABEL: 'Reporting preferences must be made by the 20th of the month to apply to the current month.'
        }
    },
    EMAIL_LOGIN: {
        HEADING: 'Log in with email',
        SUBHEADING: 'Be sure to use the number and email associated with your Flex account.',
        PHONE_LABEL: 'Mobile number',
        EMAIL_LABEL: 'Email',
        CTA: 'Continue',
        SENT_MODAL_TITLE: 'Link sent to your email',
        SENT_MODAL_BODY: 'If there is an account that matches your phone and email, the link should be in your email inbox soon. Open the link on your mobile device to log in.\n\nMake sure to check your spam folder. If you don’t receive the email, double check that you entered the correct details and try again.',
        SENT_MODAL_CTA: 'Done'
    },
    VALIDATE_MAGIC_LINK: {
        SUCCESS_MODAL_HEADING: 'Welcome back! Did your phone number change?',
        SUCCESS_MODAL_BODY: 'Your phone number is your login. Make sure your phone number on file, {{phone}}, is up-to-date to keep your account secure.',
        SUCCESS_MODAL_SUPPORT_CTA: 'Update phone number',
        SUCCESS_MODAL_CLOSE_CTA: 'Close',
        ERROR_MODAL_HEADING: 'We couldn’t log you in',
        ERROR_MODAL_BODY: 'Please try again or contact support if you continue to have issues.',
        ERROR_MODAL_CTA: 'Close'
    },
    PHONE_AUTH: {
        HEADING: 'What’s your number?',
        SUBHEADING: 'We’ll ask you to confirm this number as a way to secure your account.',
        PHONE_LABEL: 'Mobile number',
        EMAIL_LOGIN_CTA: 'Having trouble? Log in with email',
        SUBMIT_CTA: 'Send verification code'
    },
    RENT_PAYMENT: {
        TOGGLE_ENABLED_LABEL: 'Flex will attempt to pay your rent bill for {{nextBillDate}} and every following month. Turn off to pause rent payments.',
        TOGGLE_DISABLED_LABEL: 'Turn on to resume service starting with your rent bill for {{nextBillDate}}.',
        INACTIVE_DISCLAIMER_LABEL: 'Your membership has been {{accountState}}',
        WANT_TO_RESUME: 'Want to resume service?',
        GOTO_MEMBERSHIP: 'Go to Membership',
        MEMBERSHIP_CHARGED: 'Membership fee is currently being charged every month.',
        RENT_PAYMENT_SERVICE: 'Rent autopay',
        MANAGE_MEMBERSHIP: 'Manage your membership'
    },
    MEMBERSHIP_UPDATES: {
        SCREEN_TITLE: 'Membership',
        SCREEN_TITLE_SLC_CLASSIC: 'Credit line',
        MEMBERSHIP_INFO_STATE_LABEL: 'Your membership has been {{accountState}}',
        CREDIT_INFO_STATE_LABEL: 'Your credit line has been {{accountState}}',
        FLEX_CREDIT_LINE: 'Flex credit line',
        FINANCE_CHARGE: 'Finance charge',
        MONTHLY_RATE: 'Monthly rate',
        ACCOUNT_CLOSED: 'Closed',
        ACCOUNT_SUSPENDED: 'Suspended',
        MEMBERSHIP_FEE: 'Membership fee',
        NO_FEE: 'No Fee',
        REAPPLY_TO_FLEX: 'Re-apply to Flex',
        REAPPLY_INSTRUCTION: 'You must apply for a new credit line to use Flex again',
        PAY_OFF_OUTSTANDING_BALANCE: 'You must pay off your outstanding balance to re-apply',
        PAY_OFF_OUTSTANDING_BALANCE_RESUME: 'You must pay off your outstanding balance to resume',
        RESUME_SERVICE: 'Resume service',
        REQUEST_REACTIVATION: 'Request reactivation',
        EVALUATED_FOR_NEW_CREDIT_LINE: 'You’ll be evaluated for a new credit line',
        OUTSTANDING_BALANCE_TITLE: 'Outstanding balance',
        PAY_ACTION_LABEL: 'Pay',
        PAUSE_FLEX_PAYMENTS_INSTRUCTION: 'You can pause Flex payments while keeping your membership benefits by ',
        TURN_OFF_RENT_PAYMENTS: 'turning off rent payments',
        MANAGE_FLEX_DATA_INSTRUCTION: 'To manage your Flex data, ',
        GO_TO_PRIVACY: 'go to Privacy'
    },
    MEMBERSHIP_CANCEL_CARD: {
        CANCEL_MEMBERSHIP_TITLE: 'Cancel your account',
        CANCEL_MEMBERSHIP_TITLE_SUSPENDED: 'Cancel your membership',
        CANCEL_MEMBERSHIP_VALUE: 'To use Flex again, you’ll have to re-apply',
        CANCEL_ACTION_LABEL: 'Cancel'
    },
    MEMBERSHIP_RELINK_CARD: {
        RELINK_MEMBERSHIP_TITLE: 'Moving homes?',
        RELINK_MEMBERSHIP_VALUE: 'Relink your property to keep using Flex at your new address',
        RELINK_ACTION_LABEL: 'Relink'
    },
    AUTOPILOT: {
        HEADER: 'Choose a payment schedule. Flex handles the rest.',
        BODY: 'With rent autopay, Flex will automatically pay your full rent bill and split the cost into 2 payments.',
        CHECKED_LIST: ['Avoid late fees', 'Split rent into 2 payments', 'Create your own schedule'],
        NUMBERED_LIST_HEADER: 'Here’s how it works...',
        NUMBERED_LIST: [
            {
                TEXT: 'when rent is due',
                BOLD_TEXT: 'Flex collects your 1st payment'
            },
            {
                TEXT: 'directly to your property',
                BOLD_TEXT: 'Flex pays your rent in full'
            },
            {
                TEXT: 'later in the month on the date you choose',
                BOLD_TEXT: 'Flex collects your 2nd payment'
            },
        ],
        FOOTER: 'Prefer to pay with Flex manually?',
        FOOTER_BUTTON: 'Skip for now',
        CTA: 'Set up autopay'
    },
    APPROVED: {
        HEADER: 'You’ve been approved!',
        BODY: '🙌 Congrats! We’re pleased to offer you a ${{creditLine}} credit line to help pay your rent. And we’ve created a rent payment plan just for you!',
        LIST_HEADER: 'To pay your full rent of',
        LIST_ONE: 'Pay ${{bill}} by the time rent is due',
        LIST_TWO: 'Pay the remaining ${{bill}} later in the month',
        CTA: 'Continue',
        FIRST_PAYMENT: 'up front',
        SECOND_PAYMENT: 'later'
    },
    ACCEPT_MEMBERSHIP_POLICIES: {
        HEADER: 'Complete signup',
        BODY: 'Accept our membership policies to start using the Flex app to split your rent into 2 payments!',
        DISCLAIMER: 'A membership fee of {{membershipFee}} is collected every month to maintain access to your credit line',
        CTA: 'Accept'
    },
    CONGRATS: {
        HEADER: 'Congrats!',
        BODY: 'You’ve successfully completed setup',
        DOWNLOAD: 'Download the app to keep up to date with your Flex status.',
        CTA: 'Finish'
    },
    MANUAL_PAY_OVERVIEW: {
        HEADER: 'Pay rent',
        BODY: 'Ready to use Flex to pay your rent?',
        LIST_HEADER: 'Here’s how it works...',
        LIST_ONE: 'Confirm the amount you want Flex to pay to your property',
        LIST_TWO: 'Review your schedule of payments to Flex',
        LIST_THREE: 'Make your 1st payment to Flex, and submit the full rent payment to your property',
        CTA: 'Get started'
    },
    AUTOPILOT_DASHBOARD: {
        GET_READY: {
            BEFORE_BILL_PULL: {
                RENT_TRACKER_MAIN_TEXT: 'Waiting for your rent bill',
                RENT_TRACKER_SUBTEXT: 'We’ll notify you when your property has posted the bill and it’s ready to be paid.',
                RENT_TRACKER_BILL_STATUS: 'Waiting for bill'
            },
            AFTER_BILL_PULL: {
                RENT_TRACKER_MAIN_TEXT: 'Ready to pay your rent?',
                RENT_TRACKER_SUBTEXT: 'Your bill has posted and is ready to be paid. Flex can pay your bill in full and split the cost for you.',
                RENT_TRACKER_BILL_STATUS: 'Ready to be paid',
                CTA: 'Pay rent'
            }
        }
    },
    SETTINGS_PAYMENT_SCHEDULE: {
        PROCESSING_FEE_DISCLAIMER: '*Includes a {{processingFeePercentage}}% bill payment fee',
        PROCESSING_FEE_DISCLAIMER_CREDIT: '*Includes a {{processingFeePercentage}}% fee for bill payment and card processing',
        FIRST_PAYMENT_SUB_TEXT: 'When rent is due',
        SECOND_PAYMENT_SUB_TEXT: '{{paymentDay}} of each month',
        FIRST_PAYMENT_SUB_TEXT_AUTOPAY_DISABLED: 'When you start rent payment',
        SECOND_PAYMENT_SUB_TEXT_AUTOPAY_DISABLED: 'Scheduled when you start rent payment'
    },
    CONFIRM_DISABLE_RENT_AUTOPAY_MODAL: {
        TITLE: 'Turn off rent autopay?',
        DESCRIPTION_1: 'Starting with your {{nextRentBillDueDate}} bill, Flex will not pay or report your rent.',
        DESCRIPTION_2: 'Your credit line will remain open, so you can continue to use Flex to pay your rent manually. You can also turn rent autopay back on at any time.',
        DISCLAIMER: 'Your membership fee will continue to be charged on the 15th of each month',
        NEVERMIND_BUTTON: 'Never mind',
        CTA: 'Turn off'
    },
    CONFIRM_ENABLE_RENT_AUTOPAY_MODAL: {
        ENABLE_CONTENT: 'Turn on to have Flex start paying your rent bill each month.',
        DISCLAIMER_RENT_AUTOPAY: 'Rent autopay will begin with your {{nextRentBillDueDate}} rent bill',
        TITLE: 'Turn on rent autopay?',
        NEVERMIND_BUTTON: 'Never mind',
        CTA: 'Turn on'
    },
    CONFIRM_ENABLE_RENT_AUTOPAY: {
        TITLE: 'Review autopay schedule',
        SUBTITLE: 'Here’s your new rent autopay schedule. Note that you can always make changes to your 2nd payment date later.',
        TABLE_TITLE: 'Each month',
        FEE_DISCLAIMER_LABEL: COMMON.FEE_DISCLAIMER,
        FEE_DISCLAIMER_LABEL_CREDIT: COMMON.FEE_DISCLAIMER_CREDIT,
        FIRST_PAYMENT_DESCRIPTION: 'When rent is due',
        CTA: 'Accept',
        AGREE: 'I agree to the'
    },
    ENABLE_RENT_AUTOPAY_SUCCESS_MODAL: {
        TITLE: 'Autopay is on!',
        BODY: 'Flex will automatically pay your rent bill and split the cost into 2 payments every month.',
        CLOSE_CTA: 'Done',
        DISCLAIMER: 'Rent autopay will begin with your {{nextRentBillDueDate}} rent bill'
    },
    ENABLE_RENT_AUTOPAY_ERROR_MODAL: {
        TITLE: 'Set up autopay failed',
        BODY: "Sorry, we weren\u2019t able to set up autopay. Try again or contact support if the problem persists.",
        CLOSE_CTA: 'Close',
        RATE_LIMIT_ERROR_TITLE: COMMON.WAIT_TRY_AGAIN,
        RATE_LIMIT_ERROR_BODY: 'We noticed you tried to set up autopay very quickly after your last attempt. Please wait a few moments before trying again.'
    },
    RENT_AUTOPAY_CONTROL: {
        UNHANDLED_ERROR_TITLE: COMMON.SOMETHING_WENT_WRONG,
        UNHANDLED_ERROR_BODY: 'We ran into an unexpected error. Please try again or contact support if the problem persists.',
        RATE_LIMIT_ERROR_TITLE: COMMON.WAIT_TRY_AGAIN,
        RATE_LIMIT_ERROR_BODY: 'It looks like you’ve made too many requests in a short period. Please wait a moment and try again later.'
    },
    MANUAL_PAY_CONFIRM_AMOUNT: {
        HEADER: 'How much should we pay to your property?',
        LIST_HEADER: '{{date}} rent bill',
        ORIGINAL: 'Original estimate',
        ACTUAL: 'Actual bill amount',
        LAST_UPDATED: 'Last updated',
        TOGGLE_ONE: 'Bill total',
        TOGGLE_TWO: 'Custom amount',
        DISCLAIMER: '☝️ Paying less than your total bill amount may result in an overdue balance to your property.',
        CTA: 'Confirm amount'
    },
    MANUAL_PAY_PAYMENT_SCHEDULE: {
        HEADER: 'Review payment schedule',
        BODY: 'To have Flex pay ${{payment}} to your property, here’s how you’ll pay Flex.',
        LIST_HEADER: 'Schedule of payments to Flex',
        FIRST_PAYMENT: '1st payment',
        FIRST_PAYMENT_INFO: 'Today',
        SECOND_PAYMENT: '2nd payment',
        FEE_DISCLAIMER: '*Includes {{fee}}% bill payment fee',
        CHANGE_SCHEDULE: 'Change 2nd payment date',
        CTA: 'Accept'
    },
    MANUAL_PAY_PAY_NOW: {
        HEADER: 'Initiate rent payment',
        BODY: 'Ready to pay your rent? Here’s what we’ll do to make it happen.',
        FIRST_PAYMENT_HEADER: 'Flex will collect your 1st payment',
        FIRST_PAYMENT_DUE: 'Due now',
        FIRST_PAYMENT_BUTTON: 'Change',
        FLEX_RENT_HEADER: 'Flex will start processing your full rent payment',
        FLEX_RENT_PAY_TO: 'Pay to',
        FLEX_RENT_AMOUNT: 'Amount',
        CTA: 'Start payment'
    },
    MANUAL_PAY_CHANGE_SCHEDULE: {
        HEADER: 'Change 2nd payment date',
        BODY: 'Flex will automatically collect your 2nd payment on the date you choose. You can change this date later if needed.',
        CTA: 'Save'
    },
    MANUAL_PAY_CHANGE_SCHEDULE_MODAL: {
        HEADER: 'All set!',
        BODY: 'Your 2nd payment has been successfully changed.',
        CTA: 'Close'
    },
    MANUAL_PAY_PAY_NOW_FAIL_MODAL: {
        HEADER: "Couldn't complete payment",
        BODY: 'We were unable to complete your 1st payment of {{amount}} Before attempting this payment again, make sure you have enough funds available, and that your card details are correct.',
        CTA: 'Close'
    },
    MANUAL_PAY_FINISH: {
        HEADER: 'Rent payment started!',
        BODY: 'Your 1st payment of {{amount}} is complete. We’re in the process of submitting your rent payment to your property. Please allow up to 24 hours for the payment to be submitted.',
        CTA: 'Finish'
    },
    SET_UP_AUTOPAY_CARD: {
        TITLE: 'An easier way to pay',
        DESCRIPTION: 'Flex can automatically pay your rent each month!',
        CTA: 'Set up rent autopay'
    },
    SETTINGS_ACCOUNT: {
        NAME_LABEL: 'Legal name',
        EMAIL_LABEL: 'Email address',
        PHONE_LABEL: 'Phone number',
        PHONE_CHANGE_CTA: 'Change',
        MEMBERSHIP_CTA: 'Membership',
        LOGOUT_CTA: 'Log out'
    },
    UNVERIFIED_PHONE_CHANGE_MODAL: {
        TITLE: 'Email verification required',
        BODY: 'To keep your account safe, you must verify your email address before changing your phone number.',
        CANCEL_CTA: 'Never mind',
        CTA: 'Verify email'
    },
    PHONE_NOT_ELIGIBLE_CHANGE_MODAL: {
        TITLE: 'Phone number can’t be changed at this time',
        BODY: 'Check your email for more information.',
        CTA: 'Done'
    },
    PHONE_UPDATE_GENERIC_ERROR_MODAL: {
        TITLE: 'Something went wrong',
        BODY: 'We are unable to process your request at this time',
        CTA: 'Close'
    },
    UPDATE_PHONE: {
        TITLE: 'Update your phone number',
        SUBTITLE: 'We’ll ask you to confirm this number as a way to secure your account.',
        PHONE_LABEL: 'New mobile number',
        DISCLAIMER: 'By providing your phone number, you consent to receive a one-time text message from Flex. Standard message and data rates apply.',
        CTA: 'Send verification code',
        UPDATE_PHONE_ERROR: {
            TITLE: 'Unable to send code',
            BODY: 'We couldn’t send a message to {{phone}}. Make sure you provide a valid mobile number that can receive text messages.',
            CTA: 'Try again',
            EXPIRED_TITLE: 'Whoops!',
            EXPIRED_BODY: 'The link you clicked in your email has expired. For security reasons you’ll need to request a new link and try again.',
            EXPIRED_CTA: 'Ok',
            IN_USE_TITLE: 'Contact support',
            IN_USE_BODY: 'The phone number you entered needs additional verification. Please reach out to our customer support team to proceed.',
            IN_USE_CTA: 'Not now',
            IN_USE_CTA_SUPPORT: 'Contact support'
        },
        VERIFY_TOKEN_ERROR: {
            TITLE: 'Something went wrong',
            BODY: 'We are unable to process your request at this time',
            CTA: 'Close'
        }
    },
    CONFIRM_UPDATE_PHONE: {
        TITLE: 'Confirm your number',
        SUBTITLE: 'We texted a code to {{phone}}. The code will be valid for 10 minutes.',
        RESEND_CTA: 'Send a new code',
        CODE_LABEL: 'Confirmation code',
        CONFIRM_UPDATE_ERROR: {
            TITLE: 'Whoops!',
            BODY: 'The code you entered is invalid. Check for mistakes and try again.',
            CTA: 'Ok'
        },
        UPDATE_PHONE_SUCCESS_MODAL: {
            TITLE: 'Success!',
            BODY: 'Your phone number has been changed.',
            CTA: 'Done'
        },
        CLOSE_CTA: 'Close'
    },
    BILL_STATUS: {
        HEADER: 'Rent payment',
        SUBHEADER: 'Payment to property',
        AUTOPAY_TOGGLE: 'Autopay is',
        ESTIMATED: 'estimated'
    },
    RESCHEDULE_2ND_PAYMENT: {
        TITLE: 'Change 2nd payment date',
        SUBTITLE: 'Changing the date of your {{payment}} will only apply to the payment currently scheduled for {{date}}',
        INFO_WARN: {
            TITLE: 'Your next rent cycle begins soon',
            BODY: 'We recommend choosing an earlier date, so you don’t have rent payments due back to back. Moving this payment could improve your cash flow.'
        },
        INFO_GOOD: {
            TITLE: 'Smart thinking!',
            BODY: 'Scheduling toward the beginning or middle of the month gives you better control of your cash flow, and helps you stay on top of your payments each month.'
        },
        SUCCESS_MODAL: {
            TITLE: 'All set!',
            BODY: 'Your {{payment}} is scheduled to be collected on {{date}}.',
            CTA: 'Close',
            PARTIAL_PAY_BODY: 'Make a partial payment now to lower your outstanding balance before the due date.',
            PARTIAL_PAY_LINK: 'Make a partial payment'
        },
        SUBMIT_CTA: 'Confirm date',
        ERROR_MODAL: {
            TITLE: 'Oops!',
            BODY: 'We were unable to process your request.',
            CTA: 'Close'
        }
    },
    IN_NETWORK_RENT_TRACKER: {
        IN_NETWORK: {
            GET_READY: {
                MAIN_TEXT: 'Your 1st payment of {{firstPaymentAmount}} (estimated) {{daysUntilBpStarts}}',
                SUB_TEXT: 'Once we complete your 1st payment, we’ll automatically submit your rent payment.'
            }
        },
        SLC: {
            GET_READY: {
                MAIN_TEXT: 'Ensure ${{depositAmount}} is in your account for your deposit in {{daysUntilBpStarts}}.',
                SUB_TEXT: 'We’ll confirm the exact amount once your property posts the rent bill.'
            },
            FAILED_DEPOSIT: {
                MAIN_TEXT: 'We were unable to collect your payment—we’ll retry on {{retryDate}}.',
                SUB_TEXT: 'Make sure you have ${{paymentAmount}} available in your account before the retry date or make your payment now.'
            }
        }
    },
    FLEX_ANYWHERE_RENT_TRACKER: {
        DDA: {
            GET_READY: {
                BEFORE_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.MAIN_TEXT,
                    SUBTEXT: 'You’re all set up to pay your first rent bill with Flex. You’ll be able to start your rent payment and activate your Flex bank account beginning on {{bpStartDate}}.',
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.CTA
                },
                AFTER_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.MAIN_TEXT,
                    SUBTEXT: 'Let’s activate your Flex bank account so you can pay your rent bill. Ensure you have {{amount}} available for your 1st payment (estimated).',
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.CTA
                }
            },
            RENT_PAYMENT: {
                MAIN_TEXT: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.MAIN_TEXT,
                SUBTEXT: 'Your first payment has been authorized and your Flex bank account has been activated. You’re all set to make your rent payment!',
                CTA: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.CTA,
                CTA_NEW: 'Submit rent'
            },
            SECOND_PAYMENT: {
                FULLY_PAID: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FULLY_PAID.CTA
                },
                FAILED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.CTA
                },
                SCHEDULED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.CTA
                },
                SCHEDULED_THIRD_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.CTA
                }
            },
            PAYMENT_METHOD_SCREEN: {
                NOT_READY: {
                    SUBTEXT: 'Access your rent portal and use your Flex  bank account as the payment method.'
                },
                READY: {
                    SUBTEXT: 'Access your rent portal and use your Flex  bank account as the payment method.'
                }
            }
        },
        NON_SLC: {
            GET_READY: {
                BEFORE_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.CTA
                },
                AFTER_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.MAIN_TEXT,
                    SUBTEXT: 'Let’s activate your Flex debit card so you can pay your rent bill. Ensure you have {{amount}} available for your 1st payment (estimated).',
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.CTA
                }
            },
            RENT_PAYMENT: {
                MAIN_TEXT: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.MAIN_TEXT,
                SUBTEXT: 'Your first payment has been authorized and your Flex debit card has been activated. You’re all set to make your rent payment!',
                CTA: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.CTA
            },
            SECOND_PAYMENT: {
                FULLY_PAID: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FULLY_PAID.CTA
                },
                FAILED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.CTA
                },
                SCHEDULED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.CTA
                },
                SCHEDULED_THIRD_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.CTA
                }
            }
        },
        SLC_SP_ENABLED: {
            GET_READY: {
                BEFORE_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.CTA
                },
                AFTER_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.MAIN_TEXT,
                    SUBTEXT: 'Let’s activate your Flex debit card so you can pay your rent bill. Ensure you have {{amount}} available for your deposit.',
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.CTA
                }
            },
            RENT_PAYMENT: {
                MAIN_TEXT: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.MAIN_TEXT,
                SUBTEXT: 'You made your deposit and your Flex debit card has been activated. You’re all set to make your rent payment!',
                CTA: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.CTA
            },
            SECOND_PAYMENT: {
                FULLY_PAID: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FULLY_PAID.CTA
                },
                FAILED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.CTA
                },
                SCHEDULED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.CTA
                },
                SCHEDULED_THIRD_PAYMENT: {
                    MAIN_TEXT: 'Thanks for your {{paymentLabel}}!',
                    SUBTEXT: 'Your next payment of {{paymentAmount}} is {{date}}. After this payment, you’ll skip the deposit step next month.',
                    CTA: 'Make payment'
                }
            }
        },
        SLC_SP_DISABLED: {
            GET_READY: {
                BEFORE_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.BEFORE_BP_START.CTA
                },
                AFTER_BP_START: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.MAIN_TEXT,
                    SUBTEXT: 'Let’s activate your Flex debit card so you can pay your rent bill.',
                    CTA: COMMON.FLEX_ANYWHERE.GET_READY.AFTER_BP_START.CTA
                }
            },
            RENT_PAYMENT: {
                MAIN_TEXT: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.MAIN_TEXT,
                SUBTEXT: 'You made your deposit and your Flex debit card has been activated. You’re all set to make your rent payment!',
                CTA: COMMON.FLEX_ANYWHERE.RENT_PAYMENT.CTA
            },
            SECOND_PAYMENT: {
                FULLY_PAID: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FULLY_PAID.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FULLY_PAID.CTA
                },
                FAILED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.FAILED_PAYMENT.CTA
                },
                SCHEDULED_PAYMENT: {
                    MAIN_TEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.MAIN_TEXT,
                    SUBTEXT: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.SUBTEXT,
                    CTA: COMMON.FLEX_ANYWHERE.SCHEDULED_PAYMENT.CTA
                },
                SCHEDULED_THIRD_PAYMENT: {
                    MAIN_TEXT: 'Thanks for your {{paymentLabel}}!',
                    SUBTEXT: 'Your next payment of {{paymentAmount}} is {{date}}. After this payment, you’ll skip the deposit step next month.',
                    CTA: 'Make payment'
                }
            }
        }
    },
    INCOME_COLLECTION_MODAL: {
        TITLE: 'What counts as income?',
        TOP_BODY: 'Your annual gross income includes what you earn from:',
        BULLETS: [
            'Employment',
            'Investments',
            'Retirement',
            'Social security benefits',
            'Public assistance',
            'Any money deposited directly into your account (individual or joint)',
            'If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses',
        ],
        FOOTER_BODY: 'Alimony, child support, or separate maintenance income shouldn’t be included unless relied upon for credit. ',
        CTA: 'Close'
    },
    CREDIT_REPORT_INFO_MODAL: {
        TITLE: 'Why does Flex need a credit report?',
        BODY: 'Flex needs to access your credit report in order to present an offer for a Flex credit line. Your credit score and other information will be used to determine how much credit you may be offered. Your Flex credit line will determine how you’ll be able to split up your rent payments.\n\nBecause this is a “soft” credit check, your credit score will not be impacted.',
        CTA: 'Close'
    },
    FLEX_ANYWHERE_EPISODIC_PAY_NOW_FAILURE: {
        INSUFFICIENT_FUNDS_MODAL: {
            TEXT_1: 'We couldn’t complete your payment of {{paymentAmount}} due to insufficient funds.',
            TEXT_2: 'Please ensure you have enough funds available and try again.',
            TEXT_3: 'To use Flex this month, your payment must be completed by {{retryTime}} ET on {{retryDateString}}.'
        },
        GENERIC_PAYMENT_FAILURE: {
            TEXT_1: 'We couldn’t complete your payment of {{paymentAmount}} due to a temporary issue with your card or bank.',
            TEXT_2: 'You can try the payment again, or change your payment card.',
            TEXT_3: 'To use Flex this month, your payment must be completed by {{retryTime}} ET on {{retryDateString}}.'
        },
        DEFAULT_PAYMENT_FAILURE: {
            TEXT_1: 'We couldn’t complete your payment of {{paymentAmount}} due to an issue with your card or bank.',
            TEXT_2: 'Change your payment card and try again. If you think the transaction should have completed, you can try contacting your card issuer to see if they can resolve the issue.',
            TEXT_3: 'To use Flex this month, your payment must be completed by {{retryTime}} ET on {{retryDateString}}.'
        },
        UPDATE_CARD: {
            TEXT_1: 'We couldn’t complete your payment of {{paymentAmount}} due an issue with your card.',
            TEXT_2: 'Please change your payment card and try again.',
            TEXT_3: 'To use Flex this month, your payment must be completed by {{retryTime}} ET on {{retryDateString}}.'
        }
    },
    SETTINGS_RENT_PROTECT: {
        RATE_LIMIT_ERROR_TITLE: COMMON.WAIT_TRY_AGAIN,
        RATE_LIMIT_ERROR_BODY: 'We noticed you tried to update rent protect settings very quickly after your last attempt. Please wait a few moments before trying again.'
    },
    CHOOSE_DATE: {
        HEADER: 'Customize your date',
        BODY: 'Select a date for your recurring payment. Payment must be made by the end of the month so your rent can be paid the following month.',
        CTA: 'Confirm'
    },
    CHOOSE_DATE_TWO: {
        HEADER: 'Customize your dates',
        BODY: 'Select dates for your recurring payments. Payment must be made by the end of the month so your rent can be paid the following month.',
        CTA: 'Confirm',
        CTA_NEXT: 'Next'
    },
    MINIMUM_DEPOSIT_DISCLAIMER: {
        DISCLAIMER: "Based on your estimated rent of ${{rentAmount}} you'll need a minimum deposit of ${{minimumDeposit}} to activate your credit line."
    },
    SIMPLIFIED_PAYMENTS_CARD: {
        HEADER: 'Pay with your deposit',
        BODY: 'Put your deposit to good use—automatically pay off your 2nd payment instead of paying with your debit card.',
        CTA: 'Get started'
    },
    FIRST_REPAYMENT_FEEDBACK: {
        POSITIVE_FEEDBACK_HEADER: 'Smart thinking!',
        POSITIVE_FEEDBACK_BODY: 'Mid-month payments typically align with many people’s paychecks.',
        NEGATIVE_FEEDBACK_HEADER: 'Are you sure?',
        NEGATIVE_FEEDBACK_BODY: 'We recommend choosing an earlier date, so you don’t have payments due back to back. Moving this payment could improve your cash flow.'
    },
    SECOND_REPAYMENT_FEEDBACK: {
        POSITIVE_FEEDBACK_HEADER: 'Nice timing!',
        POSITIVE_FEEDBACK_BODY: 'Spacing out your 2nd payment helps smooth your cash flow.',
        NEGATIVE_FEEDBACK_HEADER: 'Heads up!',
        NEGATIVE_FEEDBACK_BODY: 'This is less than a week after your 1st payment. We’d recommend spreading these two payments out.'
    },
    APP_LOAD_ERROR: {
        HEADING: 'Something went wrong',
        BODY: 'We ran into some technical difficulties loading your account.\n\nTry again, or if the problem persists, try closing and reopening the Flex app.',
        CTA: 'Try again'
    },
    INTEREST_FEE_MODAL: {
        TITLE: 'How does interest work?',
        BODY_1: 'We keep our pricing simple and transparent.',
        BODY_2: 'You’ll pay a {{feePercent}}% monthly interest rate when you use Flex. The interest charge is calculated based on your statement balance ending on the 6th of each month. Typically, your statement balance is the same as your rent bill.',
        BODY_3: 'You are only charged interest for the months you use Flex. If you use Flex for all twelve months of the year, that equals a {{annualPercentageRate}}% Annual Percentage Rate (APR).',
        BODY_4_BOLD: 'No hidden fees. ',
        BODY_4: 'What you see on your statement balance is what you pay.',
        CTA: 'Close'
    },
    UPDATE_PORTAL_CREDENTIALS: {
        SUCCESS_MODAL: {
            TITLE: 'Connection successful',
            MESSAGE: 'You’re all set!',
            CTA: 'Done'
        }
    }
};
var OON_ACCEPTANCE_OFFER_CONTENT = {
    ACCEPTANCE_OFFER_DETAILS: {
        HEADER: 'Your schedule is ready!',
        BODY: 'You’ll use a Flex-issued payment method to pay your rent in full to your property. Review your payment schedule, which reflects your Flex credit line and any applicable fees.'
    }
};
var CONGRATS_NEW_CONTENT = {
    CONGRATS: {
        HEADER: 'Congrats!',
        BODY: 'You’ve successfully completed setup. Flex will automatically pay your rent bill and split the cost into 2 payments every month. Check your email for more info!',
        BODY_BOLD: 'Flex service will begin with your {{date}} rent bill.',
        DOWNLOAD: 'Download the app to keep up to date with your Flex status.',
        CTA: 'Finish'
    }
};
var CONGRATS_AUTOPILOT_OFF_CONTENT = {
    CONGRATS: {
        HEADER: 'Congrats!',
        BODY: 'You’ve successfully completed setup. Check your email for more info!',
        BODY_BOLD: 'Keep in mind that you’ll need to use the Flex app to start the rent payment process at the beginning of each month.',
        DOWNLOAD: 'Download the app to keep up to date with your Flex status.',
        CTA: 'Finish'
    }
};
var ACCEPTANCE_OFFER_DETAILS_EMBED_CONTENT = {
    ACCEPTANCE_OFFER_DETAILS: {
        HEADER: 'Your schedule is ready!',
        BODY: 'Finalize your schedule. You’ll be able to split your rent starting with your {{date}} rent bill.',
        FEE_DISCLAIMER: '*Includes a {{processingFeePercentage}}% bill payment fee',
        AUTHORIZATION: 'I authorize Flex to charge my card according to this payment schedule. I acknowledge that payment amounts are estimates and may vary.',
        AGREE: "By clicking 'Accept' I agree to:"
    }
};
var ACCEPTANCE_OFFER_AUTOPILOT_OFF_CONTENT = {
    ACCEPTANCE_OFFER_DETAILS: {
        HEADER: 'Complete signup',
        BODY: 'Accept our membership policies to start using the Flex app to split your rent into 2 payments!',
        MEMBERSHIP_FEE: 'A membership fee of $14.99 is collected every month to maintain access to your credit line',
        AGREE: 'I agree to the following:'
    }
};
var ADD_FUNDS_OUTSTANDING_BALANCE_MODAL_SLC_CONTENT = {
    WALLET: {
        ADD_FUNDS_OUTSTANDING_BALANCE_MODAL: {
            HEADER: 'You have an outstanding balance',
            ADD_FUNDS_OUTSTANDING_BALANCE_TEXT: 'You currently have an outstanding balance of ${{outstandingBalance}}. You’ll need to pay Flex back before adding more funds.',
            CTA: 'Close'
        }
    }
};
var ACCEPTANCE_OFFER_SLC_SIMPLIFIED_ENABLED_CONTENT = {
    ACCEPTANCE_OFFER_DETAILS: __assign(__assign({}, OON_ACCEPTANCE_OFFER_CONTENT.ACCEPTANCE_OFFER_DETAILS), { FEE_DISCLAIMER: COMMON.SLC_FEE_DISCLAIMER, FEE_DISCLAIMER_CREDIT: COMMON.SLC_FEE_DISCLAIMER })
};
var ACCEPTANCE_OFFER_SLC_SIMPLIFIED_DISABLED_CONTENT = {
    ACCEPTANCE_OFFER_DETAILS: __assign(__assign({}, OON_ACCEPTANCE_OFFER_CONTENT.ACCEPTANCE_OFFER_DETAILS), { FEE_DISCLAIMER: COMMON.SLC_FEE_DISCLAIMER, FEE_DISCLAIMER_CREDIT: COMMON.SLC_FEE_DISCLAIMER })
};
var OON_HOW_FLEX_WORKS_SIMPLIFIED_PAYMENTS_ENABLED_CONTENT = {
    OON_HOW_FLEX_WORKS: {
        BULLETS: [
            {
                HEADER: 'Get ready',
                BODY: 'Confirm your rent amount in the app and activate your credit line by making your deposit.'
            },
            {
                HEADER: 'Rent payment',
                BODY: 'Use your Flex-provided debit card to pay rent in your rent portal.'
            },
            {
                HEADER: 'Pay Flex back',
                BODY: 'We’ll automatically process your scheduled payment on the day you selected and use your deposit to pay the rest.'
            },
            {
                HEADER: 'Repeat each month!',
                BODY: ''
            },
        ]
    }
};
var OON_HOW_FLEX_WORKS_SLC_CONTENT = {
    OON_HOW_FLEX_WORKS: {
        BULLETS: [
            {
                HEADER: 'Make your deposit',
                BODY: 'Activate your credit line with your deposit. You’ll get it back when you stop using Flex.'
            },
            {
                HEADER: 'Rent payment',
                BODY: 'Confirm your rent amount in the app and use your Flex-provided debit card to pay rent in your rent portal.'
            },
            {
                HEADER: 'Pay Flex back',
                BODY: 'We’ll automatically process your 2 payments on the scheduled dates'
            },
            {
                HEADER: '',
                BODY: ''
            },
        ]
    }
};
var CUSTOMIZE_YOUR_SCHEDULE_SLC_ENABLED_CONTENT = {
    CUSTOMIZE_YOUR_SCHEDULE: {
        FIRST_PAYMENT: 'Deposit',
        SECOND_PAYMENT: 'Payment',
        BODY: 'Set up your payment schedule by selecting a date for your 2nd payment to Flex. Payment must be made by the end of the month so your rent bill can be paid the following month.'
    }
};
var REGISTER_CARD_SLC_PRICING_ENABLED_CONTENT = {
    REGISTER_CARD: {
        BODY: 'Link the debit card you’ll use for all your payments to Flex. Don’t worry, we won’t charge you until rent is due.',
        BODY_IN_APP: 'To access your line of credit, link the card you’d like to use for your payments to Flex.'
    }
};
var AGREEMENTS_UPDATE_APP_OPEN = {
    AGREEMENTS_UPDATE: {
        TITLE: 'Updates to Flex agreements',
        BODY_LINE1: 'We’re continuing to enhance the Flex product, and as a result some of our agreements have changed.',
        BODY_LINE2: 'Please review and agree to the following to continue using Flex:',
        LINK_BUTTON: '',
        CTA: 'Continue',
        AGREED: 'I have reviewed and agree to the documents above'
    }
};
var HAVING_ISSUES_MODAL_SLC_ENABLED_CONTENT = {
    SERVICE_ISSUES: {
        SELF_PAY: {
            SELF_PAY_DETAILS: {
                HAVING_ISSUES_MODAL: {
                    DONT_USE_FLEX_SUB_TEXT: 'Cancel your payments',
                    HELP_SUB_TEXT: 'Learn more about using Flex'
                }
            }
        }
    }
};
/** @deprecated we are moving away from this content providing method - see `packages/screen-content` for v2 implementation */
exports.CONTENT = {
    DEFAULT_CONTENT: exports.DEFAULT_CONTENT,
    OON_ACCEPTANCE_OFFER_CONTENT: OON_ACCEPTANCE_OFFER_CONTENT,
    CONGRATS_NEW_CONTENT: CONGRATS_NEW_CONTENT,
    CONGRATS_AUTOPILOT_OFF_CONTENT: CONGRATS_AUTOPILOT_OFF_CONTENT,
    ACCEPTANCE_OFFER_AUTOPILOT_OFF_CONTENT: ACCEPTANCE_OFFER_AUTOPILOT_OFF_CONTENT,
    ACCEPTANCE_OFFER_DETAILS_EMBED_CONTENT: ACCEPTANCE_OFFER_DETAILS_EMBED_CONTENT,
    ACCEPTANCE_OFFER_SLC_SIMPLIFIED_ENABLED_CONTENT: ACCEPTANCE_OFFER_SLC_SIMPLIFIED_ENABLED_CONTENT,
    ACCEPTANCE_OFFER_SLC_SIMPLIFIED_DISABLED_CONTENT: ACCEPTANCE_OFFER_SLC_SIMPLIFIED_DISABLED_CONTENT,
    OON_HOW_FLEX_WORKS_SIMPLIFIED_PAYMENTS_ENABLED_CONTENT: OON_HOW_FLEX_WORKS_SIMPLIFIED_PAYMENTS_ENABLED_CONTENT,
    OON_HOW_FLEX_WORKS_SLC_CONTENT: OON_HOW_FLEX_WORKS_SLC_CONTENT,
    CUSTOMIZE_YOUR_SCHEDULE_SLC_ENABLED_CONTENT: CUSTOMIZE_YOUR_SCHEDULE_SLC_ENABLED_CONTENT,
    REGISTER_CARD_SLC_PRICING_ENABLED_CONTENT: REGISTER_CARD_SLC_PRICING_ENABLED_CONTENT,
    ADD_FUNDS_OUTSTANDING_BALANCE_MODAL_SLC_CONTENT: ADD_FUNDS_OUTSTANDING_BALANCE_MODAL_SLC_CONTENT,
    AGREEMENTS_UPDATE_APP_OPEN: AGREEMENTS_UPDATE_APP_OPEN,
    HAVING_ISSUES_MODAL_SLC_ENABLED_CONTENT: HAVING_ISSUES_MODAL_SLC_ENABLED_CONTENT
};
